import {
  UPLOAD_VEKTOR,
  DOWNLOAD_VECTOR,
  ADD_FEATURE_LAYER_TO_MAP,
} from './actionTypes';
import {
  addVectorService,
  downloadVektorService,
} from '../../utils/export.import';

export const uploadVektor = (form, map, format) => (dispatch) => {
  addVectorService(form, map, format)
    .then((vectorUpload) => {
      const fileReader = new FileReader();
      fileReader.readAsText(form.target.files[0]);
      fileReader.onload = (e) => {
        let vektorData = e.target.result;
        dispatch({
          type: UPLOAD_VEKTOR,
        });
        dispatch({
          type: ADD_FEATURE_LAYER_TO_MAP,
          payload: vectorUpload,
        });
      };
    })
    .catch((err) => {});
};

export const downloadVektor = (format, layer) => (dispatch) => {
  downloadVektorService(format, layer);
  dispatch({
    type: DOWNLOAD_VECTOR,
  });
};
